import { getCurrentCurrency, initCurrencyHelper } from './currency.js'
import { getCurrentLocation, notify, setCurrentLocation } from './location.js'
import { getCurrentLanguage } from './language.js'

const DEFAULT_LOCATION = {
  country: 'FR'
}

export const initL10nConstants = async () => {
  const currentLanguage = getCurrentLanguage()

  let currentLocation = DEFAULT_LOCATION
  try {
    currentLocation = await getCurrentLocation()
  } catch (error) {
    console.error(error)
  }

  setCurrentLocation(currentLocation)

  if (window.User) {
    window.User.location = currentLocation
  }

  if (!window.CURRENCIES) {
    return { currentLanguage, currentLocation }
  }

  let currentCurrency
  try {
    currentCurrency = await getCurrentCurrency()
  } catch (error) {
    console.error(error)
  }

  if (currentCurrency) {
    initCurrencyHelper(currentLanguage, currentCurrency)
    window.CURRENCIES.CURRENT = currentCurrency
  }
  notify(currentLocation)

  return { currentLanguage, currentCurrency, currentLocation }
}
